import { PureComponent } from "react";

export default class CustomizedLabel extends PureComponent {
  render() {
    // eslint-disable-next-line react/prop-types,react/no-this-in-sfc
    const { x, y, stroke, value } = this.props;

    return (
      <text x={x} y={y} dy={-5} fill={stroke} fontSize={10} textAnchor="middle">
        {/* eslint-disable-next-line react/prop-types */}
        {parseFloat(value).toFixed(2)}
      </text>
    );
  }
}
